import { editCustomField } from 'modules/settings/submodules/customFields/components/EditCustomField/store/reducer';
import { combineReducers } from 'redux';
import { customFieldCreate } from 'modules/settings/submodules/customFields/components/CreateCustomField/store/reducers';

export const customFields = combineReducers({
    customFieldCreate,
    editCustomField,
});
